const messages = {
  201: 'Yüklediğiniz MMS dosyasının boyutu 1MB altında olmalıdır.',
  202: 'Dosya formatı desteklenmiyor. Lütfen kontrol ederek tekrar deneyiniz.',
  200: 'Beklenmedik bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
  400: 'Hatalı İstek',
  803: 'Firmanız adına işlem yapma yetkiniz bulunmamaktadır. Bu işlem sadece Özel Şifre Yetkilisi tarafından yapılabilir.',
  804: 'Servis bağlantısında (DSCS) problem oluştu. Lütfen daha sonra tekrar deneyiniz.',
  805: 'Servis bağlantısında (OMCC) problem oluştu. Lütfen daha sonra tekrar deneyiniz.',
  806: 'Servis bağlantısında (OMCC) problem oluştu. Lütfen daha sonra tekrar deneyiniz.',
  807: 'Dosya formatı desteklenmiyor. Lütfen kontrol ederek tekrar deneyiniz.',
  813: 'Mobile signature rate limit exceeded. Please try again later.',
  814: 'Çok sayıda şifre talebinde bulundunuz. Lütfen daha sonra tekrar deneyiniz.',
  815: 'E-Devlet üzerinden yapılan sorgulamada teknik bir hata yaşanmıştır. Lütfen daha sonra tekrar deneyiniz.',
  816: 'Çok sayıda IP talebinde bulundunuz. Lütfen daha sonra tekrar deneyiniz.',
  817: 'Çok sayıda kişi ekleme talebinde bulundunuz. Lütfen daha sonra tekrar deneyiniz.',
  818: 'Çok sayıda hatalı giriş yaptınız. Lütfen daha sonra tekrar deneyiniz.',
  819: 'Çok sayıda kişi ekleme talebinde bulundunuz. Lütfen daha sonra tekrar deneyiniz.',
  825: 'Bu numara için sistemde çok sayıda giriş isteği tespit edildi. Giriş talebiniz geçici olarak durdurulmuştur.',
  833: 'Geçersiz kupon kodu girdiniz.',
  835: 'Girdiğiniz kupona ait kampanya süresi dolmuştur.',
  834: 'Kampanyadan sadece bir kez yararlanabilirsiniz.',
  836: 'Kampanya icin seçilen paket uygun değildir.',
  838: 'Sisteme girişiniz geçici olarak kısıtlanmıştır.',
  839: 'Paket satın almadan önce ünvan tanımlamış olmanız gerekmektedir. Ünvan İşlemlerinden mesaj başlığı tanımı yapabilirsiniz.',
  841: 'TC Kimlik Numaranız mobil numaranın sahibiyle eşleşmemiştir. Lütfen kontrol ederek tekrar deneyiniz.',
  842: 'TC Kimlik Kontrolü sırasında beklenmedik bir hata oluştur. Lütfen daha sonra tekrar deneyiniz.',
  844: 'Bu kampanyadan yararlanamıyorsunuz.',
  845: 'Mobil numaranız paket alımına uygun değildir. Lütfen servis danışmanıyla iletişime geçiniz.',
  846: 'Ödenmemiş Turkcell faturanız olması nedeniyle paket satışı yapılamamaktadır. Yeni paket satın alabilmek için öncelikle faturalarınızı ödemeniz gerekmektedir.',
  847: 'Satın almak istediğiniz paket tutarı fatura limitinizin üzerindedir. Lütfen kontrol ederek tekrar deneyiniz.',
  848: '45 gün içersinde alabileceğiniz maksimum paket adedini aşmış bulunmaktasınız. Lütfen daha sonra tekrar deneyiniz.',
  849: 'Paket satın alma işleminiz henüz tamamlanmadığı için yeniden satın alamazsınız. Paket tanımlandığında SMS ile bilgilendirme yapılacaktır.',
  850: 'Dosya yüklerken hata oluştu. Excel dosyanın uzunluğu maksimum izin verilen kayıt sayısından fazladır.',
  851: 'Dosyada boş satır olduğu için yüklerken hata oluştu. Lütfen kontrol ederek tekrar deneyiniz.',
  855: 'Hızlı Giriş adımını onaylamadığınız için isteğiniz gerçekleştirilemedi. Lütfen yeniden deneyiniz.' ,
  996: 'Şüpheli işlem nedeniyle Mesaj Üssü kullanımınız engellenmiştir.',
  856: 'Şüpheli işlem nedeniyle Mesaj Üssü kullanımınız engellenmiştir.',
  859: 'Tek Kullanımlık şifre göndermek istediğiniz telefon numarası bu kullanıcı için kayıtlı değildir.',
  860: 'Mesaj Üssü hesabının ana numarası silinemez.',
  861: 'İlettiğiniz numara daha önce eklenmiştir.',
  862: '  Bu işlemi yapmaya yetkiliniz yok. Sadece kullanıcı numarası ile OTP giriş yapıldığında yetkilendirme yapılabilir.',
  863: 'Eklenebilecek maksimum numara sayısına eriştiniz.',
  864: 'Maksimum talep sayısına eriştiniz. Lütfen bir sonraki gün yeniden deneyiniz.',
  865: 'Mesaj metninde desteklenmeyen karakterler bulunmaktadır. Lütfen kontrol ederek yeniden deneyiniz. ',
  867: 'İlettiğiniz IP Mesaj Üssüne daha önce eklenmiştir.  ',
  868: 'Geçersiz e-mail adresi girdiniz. Lütfen kontrol ediniz.',
  869: 'Yalnızca {startHour}:00-{endHour}:00 saatleri arasında gönderim yapabilirsiniz',
  870: 'TC Kimlik Numarası hatalıdır. Lütfen kontrol ediniz.',
  871: 'Bu numara ile kayıtlı aktif bir Mesaj Üssü aboneliği bulunmamaktadır. Üye Ol butonuna tıklayarak abonelik yapabilirsiniz.',
  872: 'Faturanıza yansıtarak paket satın alabilmek için faturalı hattınızın minimum 3 aydır aktif olması gerekmektedir. Kredi kartı veya öde ve kullan yöntemi ile paket satın alabilirsiniz.',
  873: 'Faturaya yansıtma limitinizin üzerinde paket satın alamazsınız. Limit tutarınıza uygun bir paket seçebilir veya kredi kartı ya da öde ve kullan yöntemi ile herhangi bir limit olmaksızın paket satın alabilirsiniz.',
  874: 'Art arda paket alımı yapamazsınız. Lütfen birkaç dakika sonra tekrar deneyiniz.  ',
  879: 'Gönderi oluşturacak yeterli krediniz bulunmuyor. Lütfen kredi yükleyiniz.',
  880: 'Geçmiş tarihli gönderi oluşturamazsınız.',
  881: 'İleri tarihli gönderiler 1 seneden uzun olamaz.',
  882: 'Mesaj Üssü üyesi olmak için Turkcell kurumsal hatta sahip olmalısınız.',
  883: 'Gönderi oluşturmak için Ünvan işlemleri sayfasında İYS Marka Bilgisi tanımlamalısınız.',
  884: "İYS Marka Bilgisi seçimi için Aracı Hizmet Sağlayıcı olarak Turkcell'i seçmelisiniz.",
  885: 'İYS Marka Bilgisi bulunamadı.  ',
  886: '150 bin üzeri listesinde yer almadığınız için İYS Marka seçmenize gerek yoktur.',
  887: 'İYS kontolü sırasında sistemsel bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
  890: 'Art arda paket alımı yapamazsınız. Lütfen birkaç dakika sonra tekrar deneyiniz.',     
  891: 'Doğum tarihi formatını düzelterek lütfen yeniden deneyiniz.',     
  892: 'Bu numarayla yetkili tanımlayamazsınız.',  
  893: 'Abonelik süreniz kredi kartı ile satın alım için gerekli olan minimum süre ({0} gün) den daha kısa olduğu için işleminizi gerçekleştiremiyoruz..',  
  894: 'Abonelik süreniz öde ve kullan ile satın alım için gerekli olan minimum süre ({0} gün) den daha kısa olduğu için işleminizi gerçekleştiremiyoruz..', 
  895: 'Otp kontrolü için gerekli minimum sayıda smsden daha az gönderdiğiniz için otp gönderilmemiştir.',
  896: 'Mobil imza işlemi kullanıcı tarafından iptal edildi.', 
  897: 'Mobil imza işlemi zaman aşımına uğradı.', 
  900: 'Şifreniz zaman aşımına uğradı. Şifremi unuttum ekranından şifrenizi yenileyiniz.',
  901: 'Eski şifrenizi yanlış girdiniz.',
  902: 'Şifrenizi {1} defa yanlış girdiniz. {0} defa hatalı şifre girmeniz durumunda hesabınız kilitlenecektir. Şifremi unuttum adımından şifrenizi yenileyebilirsiniz.',
  903: 'Mesaj Üssü’ne Kurumsal Turkcell numarasıyla üye olabilirsiniz.',
  904: 'Lütfen ekrandaki harfleri doğru giriniz.',
  906: 'Hatalı SMS kodu girdiniz. Lütfen kontrol ederek yeniden giriniz.',
  907: 'Hesabınız kilitlenmiştir. Şifremi unuttum ekranından şifrenizi yenileyiniz.',
  909: 'Yeni şifreniz son 3 şifrenizden farklı olmalıdır.',
  910: 'Lütfen ekrandaki harfleri giriniz.',
  911: 'Şifre gönderirken hata oluştu. Lütfen tekrar deneyiniz.',
  912: 'Şifre belirlemediğiniz için lütfen şifremi unuttum bölümünden yeni şifre belirlemeniz gerekmektedir.',
  913: 'Bu numara ile kayıtlı aktif bir Mesaj Üssü aboneliği bulunmamaktadır. Üye Ol butonuna tıklayarak abonelik yapabilirsiniz.',
  '913-1':
    'Bu numara ile kayıtlı aktif bir Mesaj Üssü aboneliği bulunmamaktadır. Bu ekran üzerinden yeni üyelik oluşturabilirsiniz.',
  914: 'İşlem yapılırken hata alındı. Lütfen bilgileri kontrol ederek yeniden deneyiniz.',
  '914-1': 'Girdiğiniz şifre kriterlere uymamaktadır. Lütfen kriterlere uygun bir şifre oluşturunuz.',
  915: 'Doğrulama kodu süresi dolmuştur. Lütfen yeniden doğrulama kodu alınız.',
  916: 'Yeniden doğrulama kodu almak için lütfen birkaç dakika bekleyiniz.',
  917: 'Aynı gün içerisinde birden fazla kez şifre değişikliği yapamazsınız. Lütfen daha sonra yeniden deneyiniz.'  ,
  920: 'Beklenmedik bir hata oluştu. Lütfen sayfayı yenileyerek tekrar deneyiniz. ',
  921: 'Doğrulama kodunu birçok kez hatalı girdiniz. Lütfen yeni kod alınız.  ',
  951: 'Mesaj Üssü paketlerine erişim problemi yaşandı. Lütfen daha sonra tekrar deneyiniz.',
  955: 'Gönderi güncellenebilir durumda değil.',
  957: 'Bu isimde bir gönderim mevcut. Lütfen başka bir gönderim ismi tanımlayınız.',
  958: 'Silmek istediğiniz Ünvan şu anda aktif mesaj gönderiminde kullanıldığı için silemezsiniz.',
  959: 'Gönderdiğiniz ünvan bulunamadı.',
  960: 'Onay süreci devam eden ünvanı silemezsiniz.',
  961: 'İlettiğiniz ünvanı daha önce Mesaj Üssüne eklediniz.',
  962: 'Bu numara ile kayıtlı aktif bir Mesaj Üssü aboneliği bulunmaktadır. Giriş yap butonuna tıklayarak giriş yapabilir veya Üye Ol butonuna tıklayarak farklı bir numara için üye olabilirsiniz.',
  971: 'Geçersiz bir ünvan girdiniz. ',
  972: 'Talep ettiğiniz ünvan uygun değildir. Lütfen farklı bir ünvan belirleyiniz.',
  973: 'E-Devlet üzerinden yapılan sorgulamada teknik bir hata yaşanmıştır. Lütfen bir süre bekleyip tekrar deneyiniz.',
  974: 'Kimlik bilgileriniz doğrulanamamıştır. Lütfen bilgilerinizi kontrol edip tekrar deneyiniz.  ',
  975: 'İlletiğiniz ünvan mevcut ünvanlarınız arasında bulunmaktadır.  ',
  977: 'İlettiğiniz ünvan talebiniz onay sürecindedir. ',
  978: 'Özel Mesaj başlığı önerilen başlıkla aynı olamaz.',
  980: 'Yüklediğiniz dosyanın formatını kontrol ederek lütfen yeniden deneyiniz. ',
  981: "Mesaj uzunluğu 4 SMS'ten fazla olamaz.",
  982: 'Bu numara ile kayıtlı Mesaj Üssü aboneliğiniz iptal olmuştur. Üye Ol butonuna tıklayarak yeniden abonelik yapabilirsiniz. ',
  983: 'Numaranız kısıtlandığı için işlem yapamazsınız. Fatura borcunuz varsa ödeme yapmanız gerekmektedir. Turkcell Müşteri Yöneticiniz veya 532 Çağrı Merkezimizden detaylı bilgi alabilirsiniz.  ',
  984: 'Turkcell Mesaj Üssü aboneliğiniz yeniden aktiflendiği için şifrenizi yenilemeniz gerekmektedir.',
  985: 'Numaranızı farklı bir operatöre taşıdığınız için Turkcell Mesaj Üssü aboneliğiniz iptal olmuştur. Üye Ol butonuna tıklayarak yeni bir abonelik yapabilirsiniz.  ',
  987: 'Turkcell numaranız değiştiği için şifrenizi yenilemeniz gerekmektedir.',
  991: 'Maksimum Ünvan talep sayısına ulaştınız. Lütfen daha sonra tekrar deneyiniz. ',
  '-999': 'Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
  997: 'Talebiniz oluşturulurken bir hata oluştu.',
  999: 'Girdiğiniz numara ile Mesaj Üssü Servisinde işlem yapılamamaktadır. Lütfen kontrol ederek yeniden deneyiniz.',
  998: 'Girdiğiniz numara veya şifre hatalıdır. Lütfen numara ve şifrenizi kontrol ederek yeniden deneyiniz. Tekrar hata almanız durumunda bize ulaşın kısmından hatayı bildirerek daha fazla bilgi talep edebilirsiniz.',
  1007:'Öde ve Kullan ile ilgili bir problem oluştu. Lütfen daha sonra tekrar deneyiniz.',
  1101:'Mesaj Üssü üyelik numaranız ile sisteme giriş yaparak paket satın alabilirsiniz.',
  1102:'Satın alınacak paket bulunamadı.',
  1103:'Kredi kartı ile paket satın alma işleminizi, günlük izin verilen işlem sayısı ({0}) aşıldığı için gerçekleştiremiyoruz. Lütfen daha sonra yeniden deneyiniz.',
  1104:'Kredi kartı ile paket satın alma işleminizi, haftalık izin verilen işlem sayısı ({0}) aşıldığı için gerçekleştiremiyoruz. Lütfen daha sonra yeniden deneyiniz.',
  1105:'Kredi kartı ile paket satın alma işleminizi, aylık izin verilen işlem sayısı ({0}) aşıldığı için gerçekleştiremiyoruz. Lütfen daha sonra yeniden deneyiniz.',
  passwordMinLengthError: 'Şifre en az 6 karakter olmalıdır.',
  passwordValidationError:
    'Şifre en az büyük bir karakter, küçük bir karakter ve sayı içermelidir.',
  passwordsDoNotMatch: 'Şifre alanları birbirini tutmuyor.',
  uploadRequired: 'Alıcı seçmediniz.',
  campaignNameMissing: 'Gönderim ismi belirleyiniz.',
  senderMissing: 'Mesaj Başlığı seçiniz.',
  messageTextMissing: 'Mesaj içeriği yazınız',
  messageMediaMissing: 'Mesaj içeriği yükleyiniz',
  parameterExcelMissing: 'Excel dosyasını yükleyiniz',
  selectStartDateTime: 'Başlangıç tarihi ve saati seçiniz.',
  cantSendMoreThan5Messages:
    'Tek seferde izin verilen mesaj uzunluğunu aştınız.',
  errorNameMsg: 'İsim girmelisiniz.',
  errorSurnameMsg: 'Soyad girmelisiniz.',
  errorTcknoMsg: 'TC Kimlik no girmelisiniz.',
  errorcuzdanSeriNo: 'Cüzdan seri no girmelisiniz.',
  errorDogumTarih: 'Doğum tarihinizi seçiniz.',
  errorCompanyNameMsg: 'Kurum adı girmelisiniz.',
  errorVergiDairesi: 'Vergi dairesi girmelisiniz.',
  errorVergiNo: 'Vergi no girmelisiniz.',
  validatingThisAlpha: 'Sms başlığı girmelisiniz.',
  errorVergiLevha: 'Dosya seçmediniz.',
  errorTicariFaaliyet: 'Dosya seçmediniz.',
  errorTermsChecked: 'Sözleşmeyi kabul etmelisiniz.',
  errorGeneral: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
  excelParameterError:
    'Dosya yüklerken hata oluştu! Dosyanın (Excel) doğruluğunu kontrol ederek tekrar deneyiniz.',
  excelEmptyError:
    'Yüklediğiniz dosyada(Excel) herhangi bir kayıt bulunamamıştır. Doğruluğunu kontrol ederek tekrar deneyiniz.',
  maxThreeAlphaNumeric: 'En fazla 3 adet seçebilirsiniz.',
  alphaNumericCantChoose:
    'Şuan bekleme de olan Bireysel Başlık isteğiniz bulunduğu için sadece size önerilen listeden seçim yapabilirsiniz.',
  corporateInfoInProgress:
    'Kurum bilgileriniz onaylanana kadar işlem yapamazsınız.',
  selectTelcoInsightParameters: 'Profil kriterleri giriniz.',
  startTimeRange:
    'Yalnızca {startHour}:00-{endHour}:00 saatleri arasında gönderim yapabilirsiniz',
  beginTimeRange: 'Gönderim zamanı şu anki zamandan daha erken belirlenemez.',
  'cantDeleteCampaign': 'Gönderim silinemez',
    'waiting': 'Bekliyor',
    'preparing': 'Hazırlanıyor',
    'active': 'Gönderiliyor',
    'passive': 'Pasif',
    'stoped': 'İptal Edildi',
    'canceled': 'İptal Edildi',
    FINISHED: 'Tamamlandı',
    'paused': 'Durduruldu',
    'deliveryPending': 'Raporlanıyor',
    READY_TO_SEND: 'Bekliyor',
    NEW: 'Hazırlanıyor',
    ACTIVE: 'Gönderiliyor',
    STOP: 'İptal Edildi',
    FINISH: 'Tamamlandı',
    PAUSE: 'Durduruldu',
    "CONTACT-DUB":"Telefon numarası rehberinizde bulunmaktadır.",

            'sureToDelete': 'Silmek istediğinize emin misiniz?',
            'sureToStopCampaign': 'Gönderimi iptal etmek istediğinize emin misiniz?',
            'sureToPauseCampaign': 'Gönderimi duraklatmak istediğinize emin misiniz?',
            'sureToResumeCampaign': 'Gönderimi devam ettirmek istediğinize emin misiniz?',
            'approvePayment': 'Ödemeyi Onayla',
            'closePayment': 'Geri Dön',
            'selectPackage': 'Paket seçiniz',
            'selectPaycellCreditCard': 'Kredi Kartı Seçiniz',
            'approvePaycellCreditCard': 'Seçtiğiniz kredi kartınının sözleşmesinin onaylanması gerekmektedir.',
            'missingInformation': 'Eksik bilgi girdiniz',
            'missingCardNumber': 'Kart numarası giriniz',
            'invalidCardNumber': 'Hatalı kart numarası',
            'missingName': 'İsim giriniz',
            'missingAlias': 'Kart adı giriniz',
            'missingDate': 'Tarih giriniz',
            'missingCVC': 'CVC giriniz',
            'acceptTerms': 'Sözleşmeyi kabul ediniz',
            'alphaNumericInProgressDesc': 'Talep ettiğiniz Mesaj başlığı onay bekliyor.',
            'defaultGroupName': 'Genel Grup',
            'confirm?': 'Onaylıyor musunuz?',
            'yes': 'Evet',
            'no': 'Hayır',
            'continue': 'Devam Et',
            'cancel': 'Vazgeç',
            'ok': 'Tamam',
            'firstCreateAlphaNumericTitle': 'Gönderim oluşturmak için mesaj başlığı belirlemeniz gerekmektedir.',
            'firstCreateAlphaNumeric': 'Devam et butonuna basarak mesaj başlığı belirleyebilirsiniz',
            'alfanumerikPageFormTitle': 'Kurumsal ve kişisel bilgiler',
            'alfanumerikPageIndividualTitle': 'İsmimle göndermek istiyorum',
            'alfanumerikPageCorporateTitle': 'Marka/Firma ismimle göndermek istiyorum',
            'smsTitleInformationForApprove': 'Eğer mesaj başlığını otomatik başlıklardan seçmezseniz onay süresini beklemek zorunda kalacaksınız.',
            'alfanumerikPageSMACompanyInformation': 'SMA firmaların Mesaj başlıklarının ve generic/stratejik kelimelerin örn: TURKCELL, POLIS, SAVCI, JANDARMA vs. verilmemesi',
            'alfanumerikPageNecessityTitle': 'Gerekli belgeler',
            'alfanumerikPageCorporatePaperTitle': 'Vergi levhası yükle',
            'alfanumerikPageCorporatePaperTitleDetails': 'Şirketinize ait vergi levhanızın fotoğrafını çekip yükleyebilirsiniz.',
            'alfanumerikPageCorporateAnotherPaperTitle': 'Ticari faaliyet belgesi yükle',
            'alfanumerikPageCorporateAnotherPaperTitleDetails': ' Şirketinize ait Ticari Faaliyet belgenizin fotoğrafını çekip yükleyebilirsiniz.',
            'alfanumerikPageContractText': 'Ön bilgilendirmeyi okudum ve kabul ediyorum.',
            'alfanumerikPageLeftContractText': 'İmzalı Toplu SMS Kurumsal Sözleşmesi',
            'alfanumerikPageLeftContractTextDetails': 'Sözleşmeyi okuduğunuza dair yandaki kutucuğu işaretlemeniz yeterlidir.',
            'alfanumerikPageSubmitButtonForIndividual': 'Kaydet & Gönder',
            'smsTitleInHTwo': 'Mesaj Başlığı ',
            'smsTitleIndicationPageTitle': 'Mesaj başlığı belirleme',
            'alfaNumerikBirhtdayTitle': 'Doğum tarihi',
            'alfanumerikListPageTitle': 'Yeni mesaj başlığı belirle ',
            'alfanumerikListBrandCode': 'Yeni İYS Markası ',
            'alfanumerikListAccountName': 'Mesaj Başlığı',
            'alfanumerikListStartDate': 'Talep Tarihi',
            'alfanumerikListDeleteAccount': 'Sil',
            'alfanumerikListAccountStatus': 'Durum',
            'alfanumerikBrandCode': 'İYS Marka Bilgisi',
            'alfanumerikListPageDescription': 'Açıklama',
            'alfanumerikListSetting': 'Kullan',
            'alfanumerikSubmitSuccess': 'Mesaj Başlığı isteğiniz başarıyla alınmıştır',
            'buyCreditsYourCardInformationTitle': 'Kredi Kartı Bilgileriniz',
            'buyCreditsChooseYourPackage': 'Paket seçin',
            'buyCreditsChooseFromTurkcellCard': 'Paycell’de Kayıtlı Kredi Kartlarınız arasından seçebilirsiniz',
            'buyCreditsChooseAnyCardDropdown': 'Kredi kartı seçin',
            'buyCreditsNameSurnameInput': 'Ad, Soyad',
            'buyCreditsCreditCardName': 'Kart Adı',
            'buyCreditsWriteLikeThisCase': 'Lütfen ad ve soyadınızı kartınızın üzerinde yazdığı şekilde giriniz.',
            'buyCreditsCardName': 'Kartınızı Paycell’e hangi isimle kaydetmek istediğinizi yazınız.',
            'buyCreditsCardNumberArea': 'Kart Numarası',
            'buyCreditsSaveThisCard': 'Kartımı Paycell\'e kaydet. Kartınızı kayıt etmeniz durumunda, Kart Saklama Sözleşmesi\'ni kabul etmiş olacaksınız',
            'buyCreditsSaveThisCard1': 'Kartımı Paycell\'e kaydet. Kartınızı kayıt etmeniz durumunda, ',
            'buyCreditsSaveThisCard2': 'Kart Saklama Sözleşmesi\'ni ',
            'buyCreditsSaveThisCard3': 'kabul etmiş olacaksınız',
            'buyCreditsLastUsageDate': 'Son Kullanma Tarihi',
            'buyCreditsContractText': 'Ön bilgilendirmeyi okudum ve kabul ediyorum.',
            'buyCreditsBuyWithThisCardButton': 'Satın al',
            'dashboardSendSmsButtonText': 'Gönderim Oluştur',
            'dashboardCampaignName': 'Gönderim Adı',
            'dashboardSendDetailText': 'İşleme Durumu',
            'dashboardSendDetailDeliveredText': 'İletim Durumu',
            'dashboardDetails': 'Gönderim Detayı',
            'dashboardStartDate': 'Başlangıç Tarihi',
            'dashboardJobSuccess': 'Başarılı',
            'dashboardJobFail': 'Başarısız',
            'dashboardJobRemaining': 'Devam Eden',
            'dashboardJobWaiting': 'İşlenmeyi Bekleyen',
            'dashboardSenditText': 'İletim Raporu',
            'dashboardManageText': 'Yönet',
            'dashboardStatusText': 'Durum',
            'dashboardDetailSendName': 'Gönderim adı',
            'dashboardUsedCredit': 'Harcanan Kredi',
            'corporateAccountNotAuthorized': 'Bu işlemi yapmaya yetkiniz bulunmamaktadır. Mesaj Üssü kullanabilmek için işlem yapmak istediğiniz hattın, bağlı olduğunuz şirketin Özel Şifre Yetkilisi olması gerekmektedir. Lütfen Özel Şifre Yetkilisi ile görüşünüz. Bu numara ile işlem yapmak istiyorsanız, hattınızın Özel Şifre Yetkilisi olarak tanımlanması için lütfen Turkcell Müşteri Yöneticiniz ile iletişime geçiniz.',
            'indivualAccountNotAuthorized':'Mesaj Üssü paketi satın almak için hattınızın kurumsal hat olması gerekmektedir.',
            'otpUserNotAuthorized':'Mesaj Üssü üyelik numaranız ile sisteme giriş yaparak paket satın alabilirsiniz',
            'mvpnAccountNotAuthorized':'Bu işlemi yapmaya yetkiliniz yok. Kredi satın almak için işlem yapmak istediğiniz hattın ses (normal) hat olması gerekmektedir. ',
            'personalAlphaNotAuthorized': 'Kurumsal müşteriler İsim-Soyisim ile mesaj başlığı tanımlayamamaktadır. Lütfen Marka-Firma ismiyle göndermek ' +
            'istiyorum menüsünden mesaj başlığı tanımlayınız.',
            'mernisValidated': 'Kimlik bilgileriniz doğrulandı',
            'mernisNotValidated': 'Kimlik bilgileriniz doğrulanamadı',
            'contactUploadFileError': 'Dosya yüklerken hata oluştu! Dosyanın (Excel, Text) doğruluğunu kontrol ederek tekrar deneyiniz.',
            'contactDuplicateCircle': 'Bu isimle bir grup mevcut',
            'signupNewMember': 'Yeni Üyelik',
            'signupForgotPassword': 'Şifre Yenileme',
            'signupCompleteSignup': 'ÜYELİĞİ TAMAMLA',
            'signupChangePassword': 'ŞİFREMİ DEĞİŞTİR',
            'signupNewMessage':'Yeni üyelik oluşturmak için ilk olarak sisteme kaydolmak istediğiniz Turkcell numaranızı giriniz.',
            'signupForgotMessage':'Mesaj Üssü şifresini yenilemek istediğiniz Turkcell numaranızı giriniz',


            'rejectCode-1': 'ALFANUMERIK',
            'rejectCode-2': 'VERGINO',
            'rejectCode-3': 'VERGIDAIRESI',
            'rejectCode-4': 'VERGILEVHASI',
            'rejectCode-5': 'TICARIFAALIYET',
            'rejectCode-6': 'MAYA',

            'SIGNUP_INPROGRESS': 'Onay bekleyen bir Mesaj başlığınız vardır. Bu süreçte yeni başlık talebinde bulunamazsınız.',
            'ALPHANUMERIC_INPROGRESS': 'Onay bekleyen bir Mesaj başlığınız vardır. Bu süreçte yeni başlık talebinde bulunamazsınız.',
            'etkEnableMessage': 'ETK yasası çerçevesinde abonelere mesaj almama fırsatı tanıdınız. Bu işlem gönderim başına 1 kredi ile ücretlendirilecektir.',
            'etkDisableMessage': '6563 sayılı Elektronik Ticaret Kanunu gereğince, göndereceğiniz her ticari SMS’te, müşterilerinize SMS reddetme hakkı sunmanız zorunludur. Size özel ücretsiz sunulan bu özelliği kullanmanız tavsiye edilir.',


  			 'couponId': "Kupon ID",
            'couponCode': "Promosyon Kodu",
            'couponStatus': "Kullanım Durumu",
            'couponUser': "Kullanan Msisdn",
            'couponUsageDate': "Kullanim Tarihi",
            'couponDate': "Kupon Yaratılma Tarihi",
            'couponCodeTooltip' : "* MESAJ ÜSSÜ PROMOSYON KODUNUZ VARSA BU ALANA GİRİNİZ.",
            'couponCode': "Promosyon Kodu",
            'couponCodeTitle': "Promosyon Kodu Gir",
            'turkcellCouponInformation' : "Tebrikler! Promosyon kodunuz uygulandı. Şimdi satın al butonuna basarak ücretsiz 1500 kredinizi yükleyebilirsiniz.",
            'turkcellFreeCouponInformation' : "Tebrikler! Promosyon kodunuz uygulandı. Ücretsiz 1500 krediniz hesabınıza yüklendi.",
            'campaignCouponInformation' : "Tebrikler! Promosyon kodunuz uygulandı. Şimdi işleminize devam ederek indirimli paketi satın alabilirsiniz.",
            'couponSuccesInformation' : "Satın Alma işleminiz başarıyla gerçekleştirilmiştir.",
            'shareCouponSuccess' : "Promosyon Kodu başarılı bir şekilde paylaşılmıştır.",
            'notTurkcellNumber' : "Girdiğiniz Numara Turkcell Numarası değildir.",
            'turkcellUserError' : "Turkcell çalışanları bu kampanyadan yararlanamadığı için bu numaraya sms ile paylaşım yapamazsınız.",
            'smsSendingError' : "Promosyon kodu smsi gönderilirken hata oluşmuştur. Lütfen daha sonra tekrar deneyiniz.",
            'couponSharedUser': "Paylaşılan Msisdn",
            'buyCreditWithThisBilling': 'Satın Al',
            'buyCreditWithThisCredit': 'Satın Al',
            'radioCreditWithThisBilling': 'Turkcell Faturama Yansıt',
            'radioCreditWithThisCredit': 'Turkcell Bakiyemden Düşsün',
            'fraudMaxValue': '45 gün için faturanıza yansıtarak alabileceğiniz toplam paket tutarı  ' ,
            'fraudMaxValueSecond': 'TL dir.' ,
            'fraudMaxValueThird': 'Faturanıza yansıtarak alabileceğiniz kalan paket tutarı ' ,
            'fraudMaxValueFourth': 'TL dir.' ,
            'paymentTypeTitle': 'Ödeme Seçenekleri',
            'fraudError':'Servis durumunuz paket alımına uygun değildir. Lütfen servis danışmanıyla iletişime geçiniz.',
            'fraudAmountMessage':'45 gün içinde faturanıza yansıtarak alabileceğiniz toplam paket tutarı {totalValue} TL dir. Faturanıza yansıtarak alabileceğiniz kalan paket tutarı {remainingValue} TL dir. ',
            'loadingMessage':'Güncelleniyor...',
            'msisdn':'Telefon Numarası',
            'createDate':'Oluşturulma Tarihi',
            'name':'Ad Soyad',
            'email':'E-Posta',
            'job':'Meslek',
            'addedDate':'Kara Listeye Eklenme Tarihi',
            'removeDate':'Kara Listeden Çıkarılma Tarihi',
            'emailError': 'Geçersiz E-posta adresi',
            'msisdnError': 'Geçersiz Telefon Numarası',
            'msisdnDuplicateError': 'Telefon Numarası rehberde bulunmaktadır',
            'emptyParameterWarning': 'Gönderim listenizde parametre değeri boş olan kayıtlar bulunmaktadır. Bu şekilde gönderim yapmaya devam etmek istiyor musunuz? ',
            'deleteBlacklistOneConfirm?': 'Bu kullanıcıyı Kara Listeden çıkarmak istediğinize emin misiniz?',
            'deleteBlacklistConfirm?1': 'Seçmiş olduğunuz ',
            'deleteBlacklistConfirm?2': ' numara kara listeden çıkarılacaktır.Onaylıyor musunuz?',
            'deleteBlacklistInConfirm?1': 'Seçmiş olduğunuz ',
            'deleteBlacklistInConfirm?2': ' numara kara listeye eklenecektir.Onaylıyor musunuz?',
            'deleteBlacklistInOneConfirm?': 'Bu kullanıcıyı Kara Listeye eklemek istediğinize emin misiniz?',
            'paycellCardEmpty':'Paycell tanımlı kredi kartınız bulunmamaktadır.',
            'buyCreditWithThisVitualInvoice': 'Fatura Oluştur',
            'virtualInvoiceInfoText':'Bu yöntem ile sanal fatura oluşturarak önden ödeme yöntemi sunulmaktadır. Oluşturulan fatura ile herhangi bir bankadan ödemenizi yaparak paketlerinizi satın alabilirsiniz.',
            'infoVirtualInvoice':'Bu kısımdaki metin turkcell tarafından gelecek',
            'info':'Bilgilendirme',

            ///Yeni Eklenenler
            'zeroCreditUsage':'Harcanacak Kredi 0 olarak hesaplanmıştır. Lütfen kontrol ediniz!'

 
};
export default {
  getMessage: (code) => messages[code] ?  messages[code] :  messages['200'],
};
